<div class="pessoas-painel" role="group" [attr.aria-label]="ariaLabelLista()">
    <div class="pessoas-painel-toolbar">
        <p-iconfield iconPosition="left" class="pessoas-painel-busca">
            <p-inputicon class="pi pi-search" />
            <input pInputText type="text" placeholder="Buscar na lista..." [ngModel]="buscaLocal()" (ngModelChange)="buscaLocal.set($event)" [ngModelOptions]="{ standalone: true }" aria-label="Buscar selecionado" class="w-full" />
        </p-iconfield>
        <p-button label="Adicionar" icon="pi pi-user-plus" size="small" (click)="abrirSelecao.emit()" [disabled]="!podeAdicionar()" [pTooltip]="podeAdicionar() ? '' : tituloBotaoDesabilitado()" ariaLabel="Adicionar à seleção" />
        @if (selecionados().length > 0) {
            <p-button icon="pi pi-eraser" size="small" severity="danger" [variant]="'text'" (click)="limpar()" pTooltip="Limpar a lista" ariaLabel="Limpar a lista de selecionados" />
        }
    </div>

    @if (selecionados().length === 0) {
        <div class="pessoas-painel-vazio">
            <i class="pi pi-user-plus" aria-hidden="true"></i>
            <p>{{ rotuloVazio() }}</p>
        </div>
    } @else {
        <!-- Scroll fica NA LISTA (max-height no container, via SCSS); a coluna dos cards não rola. -->
        <p-table
            [value]="selecionadosFiltrados()"
            [rowHover]="true"
            [paginator]="selecionadosFiltrados().length > 5"
            [rows]="5"
            [rowsPerPageOptions]="[5, 10, 20]"
            paginatorDropdownAppendTo="body"
            styleClass="pessoas-painel-tabela"
            [ariaLabel]="ariaLabelLista()"
        >
            <ng-template #body let-item>
                <tr>
                    <td>
                        <div class="pessoas-painel-linha">
                            <div class="pessoas-painel-identidade">
                                @if (fotoParams(item); as foto) {
                                    <app-pessoa-avatar [idSolicitante]="foto.idSolicitante" [crm]="foto.crm" [uf]="foto.uf" [nome]="nomeDe()(item)" tamanho="lg" [clicavel]="true" (fotoSelecionada)="ampliarFoto($event)" />
                                } @else {
                                    <span class="pessoas-painel-avatar-vazio" aria-hidden="true"><i [class]="iconeSemFoto()"></i></span>
                                }
                                <div class="pessoas-painel-textos">
                                    <span class="pessoas-painel-nome" [pTooltip]="nomeDe()(item)">{{ nomeDe()(item) }}</span>
                                    <span class="pessoas-painel-subtitulo">{{ subtituloDe()(item) }}</span>
                                </div>
                            </div>
                            <p-button icon="pi pi-times" [text]="true" [rounded]="true" severity="danger" size="small" (click)="remover(item)" pTooltip="Remover da lista" [ariaLabel]="'Remover ' + nomeDe()(item) + ' da lista'" />
                        </div>
                    </td>
                </tr>
            </ng-template>
            <ng-template #emptymessage>
                <tr>
                    <td class="pessoas-painel-sem-resultado">Nenhum selecionado corresponde à busca.</td>
                </tr>
            </ng-template>
        </p-table>

        @if (ordenacoes().length > 1) {
            <div class="pessoas-painel-rodape">
                <fieldset class="pessoas-painel-ordenacao" aria-labelledby="pessoas-painel-ordenacao-label">
                    <legend class="pessoas-painel-ordenacao-label" id="pessoas-painel-ordenacao-label">Ordenar por</legend>
                    @for (ordenacao of ordenacoes(); track ordenacao.rotulo; let i = $index) {
                        <div class="pessoas-painel-ordenacao-opcao">
                            <p-radioButton [inputId]="'pessoas-painel-ordenacao-' + i" name="pessoasPainelOrdenacao" [value]="i" [ngModel]="ordenacaoIndice()" (ngModelChange)="ordenacaoIndice.set($event)" [ngModelOptions]="{ standalone: true }" />
                            <label [for]="'pessoas-painel-ordenacao-' + i">{{ ordenacao.rotulo }}</label>
                        </div>
                    }
                </fieldset>
                <small class="pessoas-painel-total">{{ selecionados().length }} {{ sufixoContador() }}</small>
            </div>
        } @else {
            <div class="pessoas-painel-rodape pessoas-painel-rodape--simples">
                <small class="pessoas-painel-total">{{ selecionados().length }} {{ sufixoContador() }}</small>
            </div>
        }
    }
</div>

<!-- Foto ampliada da pessoa (mesmo padrão do grid de PATs e da listagem de usuários). -->
<p-dialog appDialogoPadrao="pi pi-image" descricao="Foto do cadastro, em tamanho ampliado." [(visible)]="fotoAmpliadaVisivel" [style]="{ width: 'fit-content' }" header="Visualização da Foto" [dismissableMask]="true">
    @if (fotoAmpliada(); as foto) {
        <div class="flex items-center justify-center p-2">
            <img [src]="foto" alt="Foto ampliada" style="width: 300px; height: 300px; object-fit: cover; border-radius: 8px" />
        </div>
    }
</p-dialog>
